import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Informes/productividadExtraccionesMandarMatadero`, method: 'POST', body: values, token: token})
}